import React, { Component } from 'react'

// Components
import Modal from '../modal/Modal'
import Button from '../modal/Button'
import Loader from './Loader'

class DeleteConfirmationDialog extends Component {
    render() {
        const { deleteSuccess, deleteErrors } = this.props

        let buttons = []

        // Deletion was a success
        if(deleteSuccess){
            buttons = [
                {
                    type: Button,
                    text: 'Ok',
                    action: () => {
                        this.props.handleClose()
                        this.props.handleDeleteRedirect()
                    }
                }
            ]
        
        // Delete can still be confirmed
        }else{
            buttons = [
                {
                    type: Button,
                    text: 'Cancel',
                    action: () => this.props.handleClose(),
                    disabled: this.props.deleteInProcess
                },
                {
                    type: Button,
                    text: 'Yes',
                    action: () => this.props.handleDelete(this.props.id),
                    disabled: this.props.deleteInProcess
                }
            ]
        }

        return (
            this.props.show ? ( 
                <Modal title={'Confirm Deletion'} buttons={buttons}>
                    {/* Loading */}
                    {this.props.deletionInProgress ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    
                    // Show dialog content
                    ) : (
                        <div>
                            {deleteSuccess ? (
                                <div className="success msg_animate">{deleteSuccess}</div>
                            ) : (
                                <div>
                                    <div>Are you sure you want to delete this item{this.props.itemTitle ? (<span>: <div className="item_name_block">{this.props.itemTitle}</div></span>) : '?'}</div>
                                    {deleteErrors &&
                                        <div className="error msg_animate">{deleteErrors}</div>
                                    }
                                </div>
                            )}
                        </div>
                    )}
                </Modal>
            ) : (
                null
            )
        )
    }
}

export default DeleteConfirmationDialog



// WEBPACK FOOTER //
// ./src/components/utils/DeleteConfirmationDialog.js